import { EventTrackingProps } from "@/types/common";
import { Button } from "@monsterindia/global-ui-components";
import React, { useState } from "react";

import { useProfileVisibility } from "./query";

interface ProfileHiddenBtnProps {
  label?: string;
  modifier?: string;
  customClassName?: string;
  onSuccess?: () => void;
  onError?: () => void;
  handleEventTracking?: (event: EventTrackingProps) => void;
  pageName?: string;
}

const ProfileHiddenBtn: React.FC<ProfileHiddenBtnProps> = ({
  label = "Unhide Profile",
  customClassName = "",
  modifier = "primary",
  onSuccess,
  onError,
  handleEventTracking,
  pageName = "",
}) => {
  const [loading, setLoading] = useState(false);
  const { mutate } = useProfileVisibility();

  const unHideProfile = async () => {
    setLoading(true);
    mutate(
      { data: { visibleFlag: true }, action: "edit" },
      {
        onSuccess: () => {
          setLoading(false);
          onSuccess && onSuccess();
          handleEventTracking &&
            handleEventTracking({
              eventType: "eventPush",
              eventName: "profile_visibility_banner_clicked",
              eventProps: { page_name: pageName, visible_flag: true },
            });
        },
        onError: (err) => {
          setLoading(false);
          onError && onError();
          handleEventTracking &&
            handleEventTracking({
              eventType: "eventPush",
              eventName: "profile_visibility_banner_clicked",
              eventProps: { page_name: pageName, visible_flag: false },
            });
        },
      },
    );
  };
  return (
    <Button
      modifier={modifier}
      label={label}
      onClick={unHideProfile}
      isLoading={loading}
      className={customClassName}
    />
  );
};

export default ProfileHiddenBtn;
